// extracted by mini-css-extract-plugin
export default {"button":"NewCategoryButton-module__button__60tIh"};